import React from 'react';
import MarketingDetailPage from './MarketingDetailPage';
import { WEB_CONFIG } from '../constants/marketingWebColumnsConfig';

function ReportingMarketingWebPage({ team, csrfToken, currentUser, venueOwnerships }) {
  return (
    <MarketingDetailPage
      team={team}
      csrfToken={csrfToken}
      venueOwnerships={venueOwnerships}
      config={WEB_CONFIG}
    />
  );
}

export default ReportingMarketingWebPage;
